import React from 'react';
import './Line.css';

const Line = () => {
  return (
    <div className="line-page">
      <h1>线路图</h1>
      <div className="iframe-container">
        <iframe
          src="http://longtengrailway.top:26934"
          title="线路图"
          width="100%"
          height="800px"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default Line;
